
export default {
  namespaced: true,
  state: {
    loading: false,
  },
  getters: {
    loading: state => state.loading,
  },
  mutations: {
    start(state) { state.loading = true },
    end(state) { state.loading = false },
  },
  actions: {
    start({ commit }){ commit('start') },
    end({ commit }){ commit('end') },
  }
}
